import { useEffect, useState } from "react";
import { marketAPI } from "@/lib/api";

export default function MarketTicker() {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchData = async () => {
    try {
      const res = await marketAPI.getTopCoins(12);
      setCoins(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full z-[60] bg-[#0f172a] border-b border-white/10">

      <div className="ticker-container fixed top-0 left-0 w-full z-[60]
bg-black/80
backdrop-blur-md
border-b border-white/10
shadow-[0_2px_20px_rgba(0,0,0,0.6)]
">

        <div className="ticker-track">

          {[...coins, ...coins].map((coin, i) => (
            <div key={i} className="ticker-card">

              {/* ICON */}
              <img
                src={coin.image}
                className="w-4 h-4"
              />

              {/* SYMBOL */}
              <span className="ticker-symbol">
                {coin.symbol.toUpperCase()}
              </span>

              {/* PRICE */}
              <span className="ticker-price">
                ${coin.current_price}
              </span>

              {/* CHANGE */}
              <span
                className={
                  coin.price_change_percentage_24h >= 0
                    ? "ticker-green"
                    : "ticker-red"
                }
              >
                {coin.price_change_percentage_24h?.toFixed(2)}%
              </span>

            </div>
          ))}

        </div>

      </div>
    </div>
  );
}